import { UPDATE_INTERVAL_MS, shouldCheckUpdate } from './updatePolicy';

/** Mesmo relógio e mesmos gatilhos para SW, version.json e sinal opcional do banco. */
export function scheduleUpdateChecks(check: () => Promise<void>): () => void {
  let last = 0;
  let running = false;
  let disposed = false;
  const run = async () => {
    if (disposed || running || !shouldCheckUpdate(last, Date.now())) return;
    last = Date.now();
    running = true;
    try { await check(); } catch { /* rede indisponível: próxima checagem tenta novamente */ }
    finally { running = false; }
  };
  const visible = () => { if (document.visibilityState === 'visible') void run(); };
  const trigger = () => { void run(); };
  const timer = window.setInterval(trigger, UPDATE_INTERVAL_MS);
  document.addEventListener('visibilitychange', visible);
  window.addEventListener('focus', trigger);
  window.addEventListener('online', trigger);
  trigger();
  return () => {
    disposed = true;
    window.clearInterval(timer);
    document.removeEventListener('visibilitychange', visible);
    window.removeEventListener('focus', trigger);
    window.removeEventListener('online', trigger);
  };
}
